import React, { useState } from 'react';
import logo from './logo.svg';
import NotePage from './components/NotePage';
import Dashboard from './components/Dashboard';
import { BrowserRouter, Route, Routes, Link } from 'react-router-dom';

function App() {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<NotePage />} />
        <Route path="/:id" element={<NotePage />} />
        <Route path="/dashboard" element={
          <Dashboard searchTerm={searchTerm} setSearchSearchTerm={setSearchTerm} />
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
